<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Lista de materiais</h6>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col md="12">
            <table class="table mb-0 table-striped">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="col-1 border-0">ID</th>
                  <th scope="col" class="col-8 border-0">Material</th>
                  <th scope="col" class="col-1 border-0">Unid.</th>
                  <th scope="col" class="col-1 border-0">Qtd.</th>
                  <th scope="col" class="col-1 border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in productMaterial" :key="index">
                  <td>{{ item.id }}</td>
                  <td role="cell">
                    <autocomplete
                      :ref="`autocompleteMaterial_${index}`"
                      :state="state"
                      placeholder="Material"
                      :items="materials"
                      item-show="name"
                      :parameter="{ item, index }"
                      :on-input="onInputMaterial"
                      :on-select="setMaterialRow"
                    ></autocomplete>
                    <d-form-invalid-feedback>Pelo menos um produto é obrigatório</d-form-invalid-feedback>
                  </td>
                  <td><input
                        type="number"
                        class="text-center form-control md-3"
                        placeholder="m2"
                        v-model="item.unit_type.name"
                        disabled
                      />
                    </td>
                  <td role="cell" class="td-2">
                    <input
                      type="number"
                      class="text-center form-control"
                      placeholder="Qtd."
                      v-model="item.pivot.quantity"
                      required
                    />
                  </td>
                  <td role="cell" class="td-1 buttons">
                    <i class="fas fa-minus text-danger" @click="removeRow(index)" v-if="productMaterial.length > 1"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" @click="addRow()" class="btn btn-success float-right mt-3"><i class="fas fa-plus text-white"></i> Novo item</button>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Autocomplete from '_shared/Autocomplete.vue';
import { cloneDeep } from '_utils';

import { MATERIAL_ROW } from './ProductModel';

export default {
  name: 'materials',
  components: {
    Autocomplete,
  },
  data() {
    return {
      model: {
        materials: [],
      },
    };
  },
  props: {
    state: {
      type: String,
      default: '',
    },
  },
  computed: {
    productMaterial() {
      const { materials } = this.$store.state.product.product;
      if (materials) {
        return materials;
      }
      return [MATERIAL_ROW];
    },
    materials() {
      const { materialList } = this.$store.state.material;
      if (materialList && materialList.list.length) {
        return materialList.list;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getMaterialList',
    ]),

    addRow() {
      this.$store.commit('addProductMaterial', cloneDeep(MATERIAL_ROW));
    },

    removeRow(index) {
      this.$store.commit('removeProductMaterial', index);
    },

    onInputMaterial(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getMaterialList({ search: name, skip: 0, take: 10 });
      }, 500);
    },

    setMaterialInAutocomplete() {
      setTimeout(() => {
        this.productMaterial.map((material, index) => {
          if (this.$refs[`autocompleteMaterial_${index}`][0] && material.name) {
            this.$refs[`autocompleteMaterial_${index}`][0].$refs.input.value = material.name;
          }
          return material;
        });
      }, 20);
    },

    setMaterialRow(material, { item }) {
      item.name = material.name;
      item.id = material.id;
      item.unit_type = material.unit_type;
      // item.unit_type = product.unit_type;
    },
  },
  mounted() {
    this.setMaterialInAutocomplete();
  },
};
</script>

<style lang="scss" scoped>
.col {
  &-8 {
    width: 75%;
  }
}
</style>
